document.addEventListener('alpine:init', () => {
  Alpine.data('Filterable', () => ({
    filtersOpen: false,
    sortOpen: false,
    filtersCache: [],
    price_range: null,
    loading: false,
    focusedBeforeUpdate: null,
    searchParams: null,
    countHTML: null,
    filtersFormHTML: null,
    resultsHTML: null,
    drawerToggleHTML: null,
    afterUpdateCallback: null,
    isMdBreakpoint: window.isMdBreakpoint(),
    mdBreakpointMQL: window.mdBreakpointMQL(),
    swiperInstances: [], // Keep track of Swiper instances
    swiperInitializing: false, // Add a flag to track Swiper initialization

    clickOutside(event, property, sidebarOnDesktop) {
      if (!(sidebarOnDesktop && this.isMdBreakpoint)) {
        event.preventDefault();
      }

      if (
        event.target &&
        (event.target === this.$refs.filterDropDownToggle ||
          event.target === this.$refs.sortDropDownToggle)
      )
        return;

      this[property] = false;
    },

    focusOut(event, property) {
      if (event.relatedTarget) {
        if (
          event.relatedTarget === this.$refs.filterDropDownToggle ||
          event.relatedTarget === this.$refs.sortDropDownToggle
        )
          return;

        const dropdownParent = event.relatedTarget.closest(
          '[data-filterable-dropdown]'
        );

        if (!dropdownParent) {
          this[property] = false;
        }
      }
    },

    onEscape() {
      if (this.filtersOpen) {
        this.filtersOpen = false;
        this.$refs.filterDropDownToggle.focus();
      }
      if (this.sortOpen) {
        this.sortOpen = false;
        this.$refs.sortToggle.focus();
      }
    },

    init() {
      this.isMdBreakpoint = this.mdBreakpointMQL.matches;

      this.mdBreakpointMQL.addEventListener('change', (e) => {
        this.isMdBreakpoint = e.matches;
      });

      this.$root.addEventListener('baseline:filterable:open-filters', () => {
        this.filtersOpen = true;
      });

      window.addEventListener('popstate', this.onHistoryChange.bind(this));

      this.$watch('sortOpen', (value) => {
        if (value === true && this.filtersOpen === true) {
          this.filtersOpen = false;
        }
      });

      this.$watch('filtersOpen', (value) => {
        if (value === true && this.sortOpen === true) {
          this.sortOpen = false;
        }
      });

      // Initial Swiper setup
      this.reinitializeSwipers();
      this.swatchfilter();

      this.$watch('searchParams', this.onSearchParamsUpdate.bind(this));
    },

    async onSearchParamsUpdate(value, oldValue) {
      if (value === oldValue) return;

      this.loading = true;

      // Destroy existing Swiper instances before DOM update
      this.destroySwipers();


      const updatedHTML = await fetchHTML(
        currentURLAddingParams(
          [...value, ['section_id', getSectionId(this.$root)]],
          true
        )
      );

      if (this.$root.querySelector(`[data-fragment-id="count"]`)) {
        this.countHTML = querySelectorInHTMLString(
          `[data-fragment-id="count"]`,
          updatedHTML
        ).innerHTML;
      }

      if (this.$root.querySelector(`[data-fragment-id="drawer-toggle"]`)) {
        this.drawerToggleHTML = querySelectorInHTMLString(
          `[data-fragment-id="drawer-toggle"]`,
          updatedHTML
        ).innerHTML;
      }

      const filterFormFragmentIds = [
        'filters-form-sidebar',
        'filters-form-filters-drop-down',
        'filters-form-sort-drop-down',
        'filters-form-drawer',
      ];

      for (const fragmentId of filterFormFragmentIds) {
        let fragmentEl, updatedFormFragmentEl;
        if (fragmentId === 'filters-form-drawer') {
          fragmentEl = document.getElementById('filters-form-drawer');

          if (!fragmentEl) continue;

          updatedFormFragmentEl = querySelectorInHTMLString(
            `[data-template-fragment-id="${fragmentId}"]`,
            updatedHTML
          ).content.firstElementChild.querySelector(
            `[data-fragment-id="${fragmentId}"]`
          );

          if (!updatedFormFragmentEl) continue;
        } else {
          fragmentEl = this.$root.querySelector(
            `[data-fragment-id="${fragmentId}"]`
          );

          if (!fragmentEl) continue;

          updatedFormFragmentEl =
            querySelectorInHTMLString(
              `[data-fragment-id="${fragmentId}"]`,
              updatedHTML
            ) || null;

          if (!updatedFormFragmentEl) continue;
        }

        fragmentEl
          .querySelectorAll('[data-filterable-filter-fragment]')
          .forEach((filterableFragmentEl) => {
            const updatedFragment = updatedFormFragmentEl.querySelector(
              `[data-filterable-filter-fragment="${filterableFragmentEl.getAttribute(
                'data-filterable-filter-fragment'
              )}"`
            ).innerHTML;

            if (updatedFragment)
              filterableFragmentEl.innerHTML = updatedFragment;
          });
      }

      this.resultsHTML = querySelectorInHTMLString(
        `[data-fragment-id="results"]`,
        updatedHTML
      ).innerHTML;

      this.afterUpdate();
    },

    afterUpdate() {
      if (
        this.focusedBeforeUpdate &&
        document.getElementById(this.focusedBeforeUpdate)
      ) {
        const target = document.getElementById(this.focusedBeforeUpdate);

        this.$focus.focus(target);

        if (target.tagName === 'INPUT' && target.type === 'text') {
          target.select();
        }
        this.focusedBeforeUpdate = null;
      }

      if (!this.historyChanged) {
        this.updateURLHash(this.searchParams);
        this.reinitializeSwipers();

      } else {
        this.historyChanged = false;
      }

      this.loading = false;

      if (this.afterUpdateCallback) {
        this.$nextTick(() => {
          this.afterUpdateCallback();

          this.afterUpdateCallback = null;
        });
      }
    },

    reinitializeSwipers() {
      // Prevent overlapping state updates
      if (this.swiperInitializing) return;

      this.swiperInitializing = true;

      // Destroy existing Swiper instances before reinitializing
      this.destroySwipers();

      // Reinitialize Swipers after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.initializeSwiperContainers();
        this.initializeSwiperSwatches();
        this.swiperInitializing = false;
        this.swatchfilter();
      }, 50);
    },

    swatchfilter() {

      const flats = document.getElementById('btn_flats');
      const model = document.getElementById('btn_model');
      const collectionList = document.querySelector('.collection-list');
    
      // Set the initial state based on local storage
      const savedState = localStorage.getItem('viewMode');
      if (savedState === 'model') {
        collectionList.classList.add('active__model');
        model.classList.add('active');
      } else {
        flats.classList.add('active');
      }
    
      // Event listener for flats
      flats.addEventListener('click', () => {
        collectionList.classList.remove('active__model');
        localStorage.setItem('viewMode', 'flats');
    
        flats.classList.add('active');
        model.classList.remove('active');
      });
    
      // Event listener for model
      model.addEventListener('click', () => {
        collectionList.classList.add('active__model');
        localStorage.setItem('viewMode', 'model');
    
        model.classList.add('active');
        flats.classList.remove('active');
      });
    
      // Select all variant links
      let currentSwatchVariantId = null;
      let interactionStarted = false;
    
      // Handle mouseover/click for swatch links based on screen size
      const swatchLinks = document.querySelectorAll('.swatch_link');
      const isMobile = () => window.innerWidth < 768;
    
      const handleInteractionStart = (event) => {
        event.preventDefault();
        const link = event.currentTarget;
        currentSwatchVariantId = link.getAttribute('data-variant-id');
        interactionStarted = true;
        updateSwatchStyles();
      };
    
      const handleInteractionEnd = () => {
        currentSwatchVariantId = null;
        interactionStarted = false;
        updateSwatchStyles();
      };
    
      swatchLinks.forEach((link) => {
        if (isMobile()) {
          link.addEventListener('click', handleInteractionStart);
        } else {
          link.addEventListener('mouseover', handleInteractionStart);
          link.addEventListener('mouseleave', handleInteractionEnd);
        }
      });
    
      // Update event listeners on resize
      window.addEventListener('resize', () => {
        swatchLinks.forEach((link) => {
          link.removeEventListener('click', handleInteractionStart);
          link.removeEventListener('mouseover', handleInteractionStart);
          link.removeEventListener('mouseleave', handleInteractionEnd);
    
          if (isMobile()) {
            link.addEventListener('click', handleInteractionStart);
          } else {
            link.addEventListener('mouseover', handleInteractionStart);
            link.addEventListener('mouseleave', handleInteractionEnd);
          }
        });
      });
    
      // Function to update the styles of the hover images
      function updateSwatchStyles() {
        const hoverImages = document.querySelectorAll('.hover__image');
        hoverImages.forEach((image) => {
          const variantId = image.getAttribute('data-variant-id');
          const imgElement = image.querySelector('image-with-placeholder > img');
    
          if (variantId === currentSwatchVariantId) {
            image.classList.add('active');
            if (imgElement) {
              imgElement.style.opacity = '1';
              imgElement.style.zIndex = '20';
            }
          } else {
            image.classList.remove('active');
            if (imgElement) {
              imgElement.style.zIndex = 'initial';
            }
          }
        });
      }
    
      // Initial setup to ensure correct state on page load
      updateSwatchStyles();
    },
    
    

    initializeSwiperContainers() {
      const swiperContainers = document.querySelectorAll('.swiper-js-container');

      swiperContainers.forEach((element, index) => {
        const el = element.querySelector('.swiper'),
          pagination = element.querySelector('.swiper-pagination'),
          navNext = element.querySelector('.swiper-button-next'),
          navPrev = element.querySelector('.swiper-button-prev');

        if (!el) {
          console.warn(`Swiper element not found for container ${index}`);
          return;
        }

        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: .5,
          loop: false,
          pagination: false,
          breakpoints: {
            767: { slidesPerView: 1 },
            1024: { slidesPerView: 1 },
            1270: { slidesPerView: 1 },
          },
          navigation: {
            nextEl: navNext,
            prevEl: navPrev,
          }
        };

        const swiper = new Swiper(el, swiperOptions);
        this.swiperInstances.push(swiper);
        //console.log(`Swiper container instance ${index} reinitialized.`);

        let isMouseOutside = false;

        swiper.el.addEventListener('mouseleave', () => {
          isMouseOutside = true;
        });

        swiper.el.addEventListener('mouseenter', () => {
          isMouseOutside = false;
        });

        document.addEventListener('mousemove', (event) => {
          if (isMouseOutside && !swiper.el.contains(event.target)) {
            swiper.slideTo(0, 0); // Return to the first slide (index 0)
            isMouseOutside = false;
          }
        });

      });
    },
    initializeSwiperSwatches() {
      const swiperSwatches = document.querySelectorAll('.swiper-js-swatches');

      swiperSwatches.forEach((element, index) => {
        const el = element.querySelector('.swiper'),
          navNext = element.querySelector('.swiper-button-next'),
          navPrev = element.querySelector('.swiper-button-prev');

        if (!el) {
          console.warn(`Swiper swatches element not found for swatch ${index}`);
          return;
        }

        const swiperOptions = {
          slidesPerView: 5,
          spaceBetween: 0,
          loop: false,
          centerInsufficientSlides: true,
          breakpoints: {
            767: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
            1270: { slidesPerView: 5 },
          },
          navigation: {
            nextEl: navNext,
            prevEl: navPrev,
          },
        };

        const swiper = new Swiper(el, swiperOptions);
        this.swiperInstances.push(swiper);
        //console.log(`Swiper swatches instance ${index} reinitialized.`);
      });
    },

    destroySwipers() {
      // Destroy existing Swiper instances
      this.swiperInstances.forEach((swiper, index) => {
        if (swiper && swiper.destroy) {
          swiper.destroy(false, false);
          //console.log(`Swiper instance ${index} destroyed.`);
        }
      });

      this.swiperInstances = []; // Clear swiperInstances array
    },

    filterFormSubmit(event) {
      const form = event.target.closest('form');

      if (this.loading || !form) return;
      this.loading = true;

      if (
        document.activeElement &&
        this.$root.contains(document.activeElement)
      ) {
        const targetId = document.activeElement.getAttribute('id');

        if (targetId) {
          this.focusedBeforeUpdate = targetId;
        }
      }

      const formData = new FormData(event.target.closest('form'));

      this.searchParams = new URLSearchParams(formData);

      if (event.target.name && event.target.name === 'sort_by') {
        this.afterUpdateCallback = () => {
          this.sortOpen = false;
        };
      }
    },

    clearAllFilters() {
      this.searchParams = new URL(this.$event.currentTarget.href).searchParams;
    },

    updateURLHash(searchParams) {
      const searchParamsString = searchParams.toString();

      history.pushState(
        { searchParamsString },
        '',
        `${window.location.pathname}${searchParamsString && '?'.concat(searchParamsString)
        }`
      );
    },

    onHistoryChange(event) {
      this.historyChanged = true;

      this.searchParams = event.state.searchParams || '';
    },

    // Utility function to debounce mouseover events
    debounce(func, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
  }));
});
